import type { Genome } from '../../types/genome';
import { api } from '../../utils/api';

export function fetchAll() {
  return api
    .get<{ supported_references: Genome[] }>(`/genomes`)
    .then(({ data }) => data);
}
